import { render } from "./PartnershipDetail.vue?vue&type=template&id=211f9593&scoped=true"
import script from "./PartnershipDetail.vue?vue&type=script&lang=js"
export * from "./PartnershipDetail.vue?vue&type=script&lang=js"

import "./PartnershipDetail.vue?vue&type=style&index=0&id=211f9593&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211f9593"]])

export default __exports__